/**
 * External dependencies.
 */
import PropTypes from 'prop-types';
import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
/**
 * Internal dependencies.
 */
import { Header } from "./header-static";
/**
 * Default Header Component Export.
 *
 * @return {*}
 */
export default ( props ) => {
	const data = useStaticQuery(graphql`
		query HeaderQuery {
			wp {
				getHeader {
					siteLogoUrl
					siteTagLine
					siteTitle
					favicon
				}
				generalSettings {
					language
				}
			}
			headerMenu: allWpMenuItem(
				filter: {locations: {eq: WP_HEADER_MENU}}, sort: {order: ASC}
			) {
				nodes {
					id
					title: label
					cssClasses
					uri
					parentId
					path
					target
				}
			}
			headerCatMenu: allWpMenuItem(
				filter: {locations: {eq: WP_HEADER_CAT_MENU}}, sort: {order: ASC}
			) {
				nodes {
					id
					title: label
					cssClasses
					uri
					parentId
					path
				}
			}
			langMenu: allWpMenuItem(
				filter: {locations: {eq: WP_LANGUAGES_MENU}}
			) {
				nodes {
					id
					title: label
					cssClasses
					uri
					parentId
				}
			}
			topMenu: allWpMenuItem(
				filter: {locations: {eq: WP_TOP_MENU}}
			) {
				nodes {
					id
					title: label
					cssClasses
					uri
					parentId
					target
				}
			}
			socialMenu: allWpMenuItem(
				filter: {locations: {eq: WP_TOP_SOCIAL_MENU}}
			) {
				nodes {
					id
					title: label
					cssClasses
					uri
					parentId
				}
			}
			categories : allWpProductCategory(
				sort: { termOrder: ASC }
			) {
				nodes {
					name
					uri
					wpChildren {
		        nodes {
		          name
		          uri
		          link
		          termOrder
		          products {
		            nodes {
		              AcfCptProduct {
		                badge
		              }
		            }
		          }
		        }
		      }
				}
			}
		}
	`)
	return (
		<Header lang={props.lang} langReplace={props.langReplace} data={ data } className={props.className} breadcrumbs={props.breadcrumbs} />
	)
}
